/** VR / 全景视频链接的共用编辑逻辑（项目详情页头部 VR 按钮、设计侧现场媒体、任务级 VR 面板三处共用）。 */

/** 链接补全协议：没写 http(s):// 的补 https://，空串原样返回。 */
export const normalizeVrUrl = (raw) => {
  const s = String(raw || "").trim();
  if (!s) return "";
  return /^https?:\/\//i.test(s) ? s : `https://${s}`;
};

/**
 * 编辑一条 VR 时构造 PATCH 请求体。
 *  · 标题一律可改（可空）；
 *  · 链接只有 kind === "link" 才能改 —— 上传件（photo/video）改了链接就和文件对不上了；
 *  · 链接留空返回 error，交由调用方提示。
 */
export const buildVrEditPatch = (item, { title = "", url = "" } = {}) => {
  const patch = { title: String(title || "").trim() };
  if (item?.kind === "link") {
    const u = normalizeVrUrl(url);
    if (!u) return { error: "empty_url" };
    patch.url = u;
  }
  return { patch };
};
